<template>
<div class="chapter">
<div class="inner_page">
<div><a id="toc"></a></div>
<h4 class="fronthead">Table of Contents</h4>
<p class="toc"><a href="#/html/04_intro#intro">Introduction</a></p>
<p class="toc"><a href="#/html/05_c1#c1">Chapter 1 - Meeting the Dogg Father</a></p>
<p class="toc"><a href="#/html/06_c2#c2">Chapter 2 - Getting Snoop to Playboy</a></p>
<p class="toc"><a href="#/html/07_c3#c3">Chapter 3 - Trial run &amp; Carmelo</a></p>
<p class="toc"><span href="#/html/08_c4#c4" title="Link target outside of Sample">Chapter 4 - Buckwild Bus Tour</span></p>
<p class="toc"><span href="#/html/09_c5#c5" title="Link target outside of Sample">Chapter 5 - Buckwild Temptations</span></p>
<p class="toc"><span href="#/html/10_c6#c6" title="Link target outside of Sample">Chapter 6 - Playboy 50<sup>th</sup> &amp; Melyssa Ford</span></p>
<p class="toc"><span href="#/html/11_c7#c7" title="Link target outside of Sample">Chapter 7 - The Roadshow</span></p>
<p class="toc"><span href="#/html/12_c8#c8" title="Link target outside of Sample">Chapter 8 - Studio Sessions with Snoop</span></p>
<p class="toc"><span href="#/html/13_c9#c9" title="Link target outside of Sample">Chapter 9 - Mase the Holy Freak</span></p>
<p class="toc"><span href="#/html/14_c10#c10" title="Link target outside of Sample">Chapter 10 - Anna Nicole Smith</span></p>
<p class="toc"><span href="#/html/15_c11#c11" title="Link target outside of Sample">Chapter 11 - Fight Night at the Vibe Awards</span></p>
<p class="toc"><span href="#/html/16_c12#c12" title="Link target outside of Sample">Chapter 12 - MTV New Year’s Eve 2004/Super Bowl</span></p>
<p class="toc"><span href="#/html/17_c13#c13" title="Link target outside of Sample">Chapter 13 - Pitching Shows with/The Firm</span></p>
<p class="toc"><span href="#/html/18_c14#c14" title="Link target outside of Sample">Chapter 14 - How the West was One</span></p>
<p class="toc"><span href="#/html/19_c15#c15" title="Link target outside of Sample">Chapter 15 - Atlanta with BMF</span></p>
<p class="toc"><span href="#/html/20_c16#c16" title="Link target outside of Sample">Chapter 16 - BET Awards 2005 &amp; Hoopz</span></p>
<p class="toc"><span href="#/html/21_c17#c17" title="Link target outside of Sample">Chapter 17 - Hurricane Katrina</span></p>
<p class="toc"><span href="#/html/22_c18#c18" title="Link target outside of Sample">Chapter 18 - Boss ‘N Up Movie &amp; Tour in Japan</span></p>
<p class="toc"><span href="#/html/23_c19#c19" title="Link target outside of Sample">Chapter 19 - Australia</span></p>
<p class="toc"><span href="#/html/24_c20#c20" title="Link target outside of Sample">Chapter 20 - MTV Australia &amp; Russell Crowe</span></p>
<p class="toc"><span href="#/html/25_c21#c21" title="Link target outside of Sample">Chapter 21 - Auckland/The Friendly Skies</span></p>
<p class="toc"><span href="#/html/26_c22#c22" title="Link target outside of Sample">Chapter 22 - Private Jets &amp; Hotels Suites</span></p>
<p class="toc"><span href="#/html/27_c23#c23" title="Link target outside of Sample">Chapter 23 - Snoop’s Youth Football</span></p>
<p class="toc"><span href="#/html/28_c24#c24" title="Link target outside of Sample">Chapter 24 - Michelle the Stallion</span></p>
<p class="toc"><span href="#/html/29_c25#c25" title="Link target outside of Sample">Chapter 25 - Ray J &amp; Kim K</span></p>
<p class="toc"><span href="#/html/30_c26#c26" title="Link target outside of Sample">Chapter 26 - A New Edition Wedding</span></p>
<p class="toc"><span href="#/html/31_c27#c27" title="Link target outside of Sample">Chapter 27 - Bad Feeling</span></p>
<p class="toc"><span href="#/html/32_c28#c28" title="Link target outside of Sample">Chapter 28 - Hemmed Up at Heathrow</span></p>
<p class="toc"><span href="#/html/33_c29#c29" title="Link target outside of Sample">Chapter 29 - South Africa &amp; Leonardo DiCaprio</span></p>
<p class="toc"><span href="#/html/34_c30#c30" title="Link target outside of Sample">Chapter 30 - South Africa II</span></p>
<p class="toc"><span href="#/html/35_c31#c31" title="Link target outside of Sample">Chapter 31 - The End of the Road</span></p>
<p class="toc"><span href="#/html/36_bonus#bonus" title="Link target outside of Sample">Bonus Chapter - My Stevie Wonder Encounters</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_toc.vue?3ffd35aa